module.exports = __webpack_public_path__ + "static/img/flow2.afb96be2.svg";